
namespace GeniuzPOS.InitialData {
    import fld = PsPanelGroupButtonRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PsPanelGroupButtonGrid extends Serenity.EntityGrid<PsPanelGroupButtonRow, any> {
        protected getColumnsKey() { return PsPanelGroupButtonColumns.columnsKey; }
        protected getDialogType() { return PsPanelGroupButtonDialog; }
        protected getIdProperty() { return PsPanelGroupButtonRow.idProperty; }
        protected getInsertPermission() { return PsPanelGroupButtonRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPanelGroupButtonRow.localTextPrefix; }
        protected getService() { return PsPanelGroupButtonService.baseUrl; }

        
        private _CallPR: string;
        
        constructor(container: JQuery) {
            super(container);
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;
    
            this.view.params.EqualityFilter = this.view.params.EqualityFilter || {};
            this._CallPR = this.view.params.EqualityFilter["TouchPanelType"];
            console.log(this._CallPR)
            return true;
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }

        //date pickup
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.TouchPanelType).init = w => {

                //(w as Serenity.DateEditor).valueAsDate = new Date(Date.now());
                let x = Q.tryFirst(PsPosTouchPanelTypeRow.getLookup().items, x=> x.TouchPanelType != null);
                
                (w as Serenity.StringEditor).value = x.TouchPanelType

                this._CallPR = (w as Serenity.StringEditor).value
                
            };



            // var q = Q.parseQueryString();
            // if (q["TouchPanelType"]) {
            //     var category = Q.tryFirst(filters, x => x.field == "TouchPanelType");
            //     category.init = e => {
            //         e.element.getWidget(Serenity.LookupEditor).value = q["TouchPanelType"];
            //     };
            // }


            return filters;
        }

        // protected createQuickFilters(): void {

        //     // let base class to create quick filters first
        //     super.createQuickFilters();

        //     let x = Q.tryFirst(PsPosTouchPanelTypeRow.getLookup().items, x=> x.TouchPanelType != null)

        //     // find a quick filter widget by its field name
        //     this.findQuickFilter(Serenity.StringEditor, fld.TouchPanelType).value = [x.TouchPanelType];
        // }
    }
}